import { Link } from '@tanstack/react-router';
import Button from '../ui/Button.jsx';
import Reveal from '../ui/Reveal.jsx';
import SplitText from '../ui/SplitText.jsx';
import TerminalSimulator from './TerminalSimulator.jsx';
import { cta } from '../../content/site.js';

/**
 * CTA — closing section immediately above the footer.
 * Renders a responsive two-column grid layout on desktop:
 * - Left: SplitText headline, body copy, and primary intake CTA.
 * - Right: Interactive TerminalSimulator simulating a diagnostic workflow audit.
 */
export default function CTA() {
  return (
    <section
      id="cta"
      className="relative overflow-hidden isolate bg-surface text-ink-50 py-[clamp(88px,12vw,140px)] border-t border-white/[.06]"
    >
      <div className="container-page">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Copy Column (Left) */}
          <div className="lg:col-span-5 flex flex-col justify-center text-center lg:text-left">
            <h2 className="mb-6 text-display-lg lg:text-display-xl leading-tight">
              <SplitText startOnView text={cta.headline} accent={cta.headlineAccent} />
            </h2>

            <Reveal as="p" delay={120} className="text-ink-200 text-body-lg max-w-[58ch] lg:max-w-[48ch] mx-auto lg:mx-0 mb-9">
              {cta.body}
            </Reveal>

            <Reveal delay={200} className="flex justify-center lg:justify-start">
              <Button variant="primary" as={Link} to={cta.primary.href}>
                {cta.primary.label}
              </Button>
            </Reveal>
          </div>

          {/* Terminal Simulator Column (Right) */}
          <div className="lg:col-span-7 w-full max-w-[640px] mx-auto lg:max-w-none">
            <Reveal delay={280}>
              <TerminalSimulator />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
